import React, { forwardRef } from "react";
import { MigrationNudgeZone } from "../../layouts/MigrationNudgeLayout/MigrationNudgeLayout";
import { Content } from "./Content";
import { Divisions } from "./Divisions";
export const MigrationNudge = forwardRef(({ CTAUrl, onCTAClick }, ref) => {
    return (<MigrationNudgeZone ref={ref}>
        <Content CTAUrl={CTAUrl} onCTAClick={onCTAClick}/>
        <Divisions />
      </MigrationNudgeZone>);
});
MigrationNudge.displayName = "MigrationNudge";
